import { render, staticRenderFns } from "./direccion.vue?vue&type=template&id=12df9eb8&"
import script from "./direccion.vue?vue&type=script&lang=ts&"
export * from "./direccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports